.fancyToggle {
  --ixf-fancy-toggle-input-background: transparent;
  --ixf-fancy-toggle-input-padding-top: 0;
  --ixf-fancy-toggle-input-padding-bottom: 0;

  // Size default: medium
  --ixf-fancy-toggle-input-height: 40px;
  --ixf-fancy-toggle-input-padding-left: var(--ixf-space-4);
  --ixf-fancy-toggle-input-padding-right: var(--ixf-space-4);
  --ixf-fancy-toggle-font-size: 0.875rem;
  --ixf-fancy-toggle-line-height: 1.125rem;
  --ixf-fancy-toggle-border-radius: 8px;
  --ixf-fancy-toggle-text-align: center;

  &.size {
    &-small {
      --ixf-fancy-toggle-input-height: 32px;
      --ixf-fancy-toggle-border-radius: 6px;
      --ixf-fancy-toggle-input-padding-left: var(--ixf-space-3);
      --ixf-fancy-toggle-input-padding-right: var(--ixf-space-3);

      .button.hasIcon.icon-position {
        &-left {
          --ixf-fancy-toggle-input-padding-left: var(--ixf-space-2);
        }

        &-right {
          --ixf-fancy-toggle-input-padding-right: var(--ixf-space-2);
        }
      }
    }

    &-large {
      --ixf-fancy-toggle-input-height: fit-content;
      --ixf-fancy-toggle-input-padding-left: var(--ixf-space-6);
      --ixf-fancy-toggle-input-padding-right: var(--ixf-space-6);
      --ixf-fancy-toggle-font-size: 1rem;
      --ixf-fancy-toggle-line-height: 1.5rem;
      --ixf-fancy-toggle-border-radius: var(--ixf-border-radius-2);
      --ixf-fancy-toggle-input-padding-top: var(--ixf-space-3);
      --ixf-fancy-toggle-input-padding-bottom: var(--ixf-space-3);

      .button.hasIcon.icon-position {
        &-left {
          --ixf-fancy-toggle-input-padding-left: var(--ixf-space-3);
          --ixf-fancy-toggle-input-padding-right: var(--ixf-space-4);
        }

        &-right {
          --ixf-fancy-toggle-input-padding-right: var(--ixf-space-5);
        }
      }
    }
  }

  .button {
    display: flex;
    cursor: pointer;
    height: var(--ixf-fancy-toggle-input-height);
    padding: var(--ixf-fancy-toggle-input-padding-top) var(--ixf-fancy-toggle-input-padding-right) var(--ixf-fancy-toggle-input-padding-bottom) var(--ixf-fancy-toggle-input-padding-left);
    border-radius: var(--ixf-fancy-toggle-border-radius);
    background: var(--ixf-fancy-toggle-input-background);
    box-shadow: var(--ixf-box-shadow-fancy-radio);
    color: var(--ixf-text-tone-md);
    font-weight: var(--ixf-font-weight-main-medium);
    font-size: var(--ixf-fancy-toggle-font-size);
    line-height: var(--ixf-fancy-toggle-line-height);
    text-align: var(--ixf-fancy-toggle-text-align);
    align-items: center;

    &:hover, &.isActive {
      --ixf-fancy-toggle-input-background: var(--ixf-color-neutral-xlt);
    }

    &:disabled {
      cursor: pointer;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: none;
      box-shadow: var(--ixf-box-shadow-fancy-radio-focus);
    }

    &.isActive {
      box-shadow: var(--ixf-box-shadow-fancy-radio-active);
    }

    &.withSubtitle {
      --ixf-fancy-toggle-input-padding-bottom: var(--ixf-space-4);
      --ixf-fancy-toggle-text-align: left;
    }

    &.hasIcon {
      &.icon-position {
        &-left {
          --ixf-fancy-toggle-input-padding-left: var(--ixf-space-3);
        }

        &-right {
          --ixf-fancy-toggle-input-padding-right: var(--ixf-space-3);
        }
      }
    }

    svg {
      height: 16px;
    }
  }
}
